import { postFetch } from '../fetch';
import { apiConfig } from '../config';

export function postCreateQuiz(quiz: any) {
    const { apiPostCreateQuiz } = apiConfig.getStaticUrls();

    return postFetch(apiPostCreateQuiz, quiz);
}
